var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionGrantRewards } from "./actionGrantRewards";
var initial = {};
export var reducerGrantRewards = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionGrantRewards.Received:
            var rewards = action.rewards, rewardsType = action.rewardsType;
            return __assign({}, state, { rewards: rewards,
                rewardsType: rewardsType });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/grant-rewards/reducerGrantRewards.ts
// module id = 2530
// module chunks = 3